module.exports = __webpack_public_path__ + "static/img/ai审核_产品截图2@2x.eead18af.png";